import {makeAutoObservable} from "mobx";
import {displayErrorDialogPrompt} from "../common/util/errror/log.util";

export const getDayPath = (day) => {
    return day % 2 === 0 ? 'even' : 'odd';
}

export const getDefaultContentUrl = (step, day) => {
    return `steps/${step}/days/${day}`;
}

const logPrefix  = "[ContentStore]"
export default class ContentStore {

    constructor(props) {
        this.contentRepository = props.contentRepository;
        this.aiRepository = props.aiRepository;
        this.dialogStore = props.dialogStore;
        this.commonStore = props.commonStore;
        this.stepValue = 1;
        this.dayValue = 1;

        this.isReadyToMoveExit = false;
        this.isReadyToSaveContent = false;
        this.isOnContentPage = false;

        this.mainText = '';
        this.textField = '';

        this.createImgText = '';
        this.dividedTextList = [];

        this.onSave = null;

        makeAutoObservable(this);
    };

    setOnSave = (func) => {
        this.onSave = func;
    };

    initStepAndDayValue = () => {
        this.setStepValue(1);
        this.setDayValue(1);
    };

    setReadyToMoveExit = (bool) => {
        this.isReadyToMoveExit = bool;
    };
    setReadyToSaveStep = (bool) => {
        this.isReadyToSaveContent = bool;
    };
    setCurrentContentPage = (bool) => {
        this.isOnContentPage = bool;
    };

    setStepValue = (num) => {
        this.stepValue = num;
    };
    setDayValue = (num) => {
        this.dayValue = num;
    };

    setContentTapIndex = (index) => {
        this.contentTapIndex = index;
    };

    openErrorDialog = (info) => {
        if (this?.dialogStore) {
            this.dialogStore.openErrorDialog(info)
        }
    };


    * getGeneratedImage(text, callback) {
        this.commonStore.setLoadingState('이미지를 자동으로 생성 중입니다.');
        try {
            console.log(logPrefix, 'Start getGeneratedImage.');
            const url = `?text=${text}`;
            const result = yield this.aiRepository.getImage(url);
            console.log(logPrefix, 'Finished getGeneratedImage.');
            callback && callback('data:image/png;base64,' + result.data);

            this.openErrorDialog({
                titleText: '완료',
                text: '이미지 자동 생성 완료'
            });
        } catch (e) {
            console.log(logPrefix, 'Failed getGeneratedImage. error=' + e);

            this.openErrorDialog({
                titleText: '이미지 생성 오류',
                text: displayErrorDialogPrompt(e, '이미지 생성 도중 에러가 발생했습니다.')
            });
        } finally {
            this.commonStore.initLoadingState();
        }
    }

    * getGeneratedTTS(languageCode, voiceType, text, callback) {
        this.commonStore.setLoadingState('오디오를 자동으로 생성 중입니다.');
        try {
            console.log(logPrefix, 'Start getGeneratedTTS.');
            const url = `?languageCode=${languageCode}&voiceType=${voiceType}&text=${text}`;
            const result = yield this.aiRepository.getTTS(url);
            console.log(logPrefix, 'Finished getGeneratedTTS.');
            callback && callback(result.data);

            this.openErrorDialog({
                titleText: '완료',
                text: '오디오 자동 생성 완료'
            });
        } catch (e) {
            console.log(logPrefix, 'Failed getGeneratedTTS. error=' + e);

            this.openErrorDialog({
                titleText: 'TTS 생성 오류',
                text: displayErrorDialogPrompt(e, 'TTS 생성 도중 에러가 발생했습니다.')
            });
        } finally {
            this.commonStore.initLoadingState();
        }
    }

    * getGeneratedTTSWithAzure(languageCode, voiceType, text, callback) {
        this.commonStore.setLoadingState('오디오를 자동으로 생성 중입니다.');
        try {
            console.log(logPrefix, 'Start getGeneratedTTS.');
            const url = `?languageCode=${languageCode}&voiceType=${voiceType}&text=${text}`;
            const result = yield this.aiRepository.getTTSWithAzure(url);
            console.log(logPrefix, 'Finished getGeneratedTTS.');
            callback && callback(result.data);

            this.openErrorDialog({
                titleText: '완료',
                text: '오디오 자동 생성 완료'
            });
        } catch (e) {
            console.log(logPrefix, 'Failed getGeneratedTTS. error=' + e);

            this.openErrorDialog({
                titleText: 'TTS 생성 오류',
                text: displayErrorDialogPrompt(e, 'TTS 생성 도중 에러가 발생했습니다.')
            });
        } finally {
            this.commonStore.initLoadingState();
        }
    }

    * getGeneratedTTSWithGoogle(languageCode, voiceType, text, callback) {
        this.commonStore.setLoadingState('오디오를 자동으로 생성 중입니다.');
        try {
            console.log(logPrefix, 'Start getGeneratedTTS.');
            const url = `?languageCode=${languageCode}&voiceType=${voiceType}&text=${text}`;
            const result = yield this.aiRepository.getTTSWithGoogle(url);
            console.log(logPrefix, 'Finished getGeneratedTTS.');
            callback && callback(result.data);

            this.openErrorDialog({
                titleText: '완료',
                text: '오디오 자동 생성 완료'
            });
        } catch (e) {
            console.log(logPrefix, 'Failed getGeneratedTTS. error=' + e);

            this.openErrorDialog({
                titleText: 'TTS 생성 오류',
                text: displayErrorDialogPrompt(e, 'TTS 생성 도중 에러가 발생했습니다.')
            });
        } finally {
            this.commonStore.initLoadingState();
        }
    }


    * getGeneratedTranslate(languageCode, text, callback) {
        this.commonStore.setLoadingState('번역문을 자동으로 생성 중입니다.');
        try {
            console.log(logPrefix, 'Start getGeneratedTranslate.');
            const url = `?languageCode=${languageCode}&text=${text}`;
            const result = yield this.aiRepository.getTranslate(url);
            console.log(logPrefix, 'Finished getGeneratedTranslate.');

            callback && callback(result.data);

            this.openErrorDialog({
                titleText: '완료',
                text: '번역 자동 생성 완료'
            });
        } catch (e) {
            console.log(logPrefix, 'Failed getGeneratedTranslate. error=' + e);

            this.openErrorDialog({
                titleText: '번역 생성 오류',
                text: displayErrorDialogPrompt(e, '번역 생성 도중 에러가 발생했습니다.')
            });
        } finally {
            this.commonStore.initLoadingState();
        }
    }

    * getGeneratedSentence(languageCode, text, callback) {
        this.commonStore.setLoadingState('문장을 자동으로 생성 중입니다.');
        try {
            console.log(logPrefix, 'Start getGeneratedTranslate.');
            const url = `?languageCode=${languageCode}&text=${text}`;
            const result = yield this.aiRepository.getSentence(url);
            console.log(logPrefix, 'Finished getGeneratedTranslate.');

            callback && callback(result.data);

            this.openErrorDialog({
                titleText: '완료',
                text: '문장 자동 생성 완료'
            });
        } catch (e) {
            console.log(logPrefix, 'Failed getGeneratedTranslate. error=' + e);

            this.openErrorDialog({
                titleText: '문장 생성 오류',
                text: displayErrorDialogPrompt(e, '문장 생성 도중 에러가 발생했습니다.')
            });
        } finally {
            this.commonStore.initLoadingState();
        }
    }

    * getGeneratedWords(languageCode, generateCount, callback) {
        let loadingText = '단어를 자동으로 생성 중입니다.';
        if (generateCount > 5) {
            loadingText = '퀴즈를 자동으로 생성 중입니다.';
        }
        this.commonStore.setLoadingState(loadingText);
        try {
            console.log(logPrefix, 'Start getGeneratedWords.');
            const url = `?languageCode=${languageCode}&generate-count=${generateCount}`;
            const result = yield this.aiRepository.getWords(url);
            console.log(logPrefix, 'Finished getGeneratedWords.');

            callback && callback(result.data);

            this.openErrorDialog({
                titleText: '완료',
                text: '단어 자동 생성 완료'
            });
        } catch (e) {
            console.log(logPrefix, 'Failed getGeneratedWords. error=' + e);

            this.openErrorDialog({
                titleText: '단어 생성 오류',
                text: displayErrorDialogPrompt(e, '단어 생성 도중 에러가 발생했습니다.')
            });
        } finally {
            this.commonStore.initLoadingState();
        }
    }
}

